/**
 * Formuláře – vylepšení všech <select> knihovnou Choices.js.
 *
 * Choices je globál z vendor bundle (js/vendor/choices/choices.min.js).
 * Opt-out: na select stačí dát atribut data-no-choices.
 */
function initChoices() {
    if (typeof Choices === 'undefined') return;

    document.querySelectorAll('select').forEach((select) => {
        // přeskoč vyřazené a už inicializované (Choices obalí select do .choices)
        if (select.hasAttribute('data-no-choices') || select.closest('.choices')) return;

        new Choices(select, {
            searchEnabled: select.options.length > 8, // hledání jen u delších seznamů
            shouldSort: false,                         // zachovat pořadí <option>
            allowHTML: false,
            itemSelectText: '',                        // pryč "Press to select"
            loadingText: 'Načítání…',
            noResultsText: 'Žádné výsledky',
            noChoicesText: 'Žádné možnosti',
        });
    });
}

/**
 * Přílohy u poptávky — append místo replace + odebírání jednotlivých souborů.
 * Nativní <input type=file multiple> při novém výběru předchozí soubory zahodí a
 * neumí odebrat jednu položku. Držíme vlastní seznam a přes DataTransfer ho zrcadlíme
 * zpět do input.files, aby se odeslal serveru. Limity jsou jen UX — server je autorita.
 */
function initFileInputs() {
    document.querySelectorAll('.form-group input[type="file"]').forEach((input) => {
        if (input.dataset.fileEnhanced) return;
        input.dataset.fileEnhanced = '1';

        const maxFiles = parseInt(input.dataset.maxFiles || '0', 10) || Infinity;
        const maxSize  = parseInt(input.dataset.maxSize || '0', 10) || Infinity;
        const group    = input.closest('.form-group');
        const list     = group ? group.querySelector('.form-file-list') : null;
        const errBox   = group ? group.querySelector('.form-file-error') : null;
        const files    = [];

        const fmtSize = (b) => (b >= 1048576 ? (b / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(b / 1024)) + ' kB');
        const keyOf   = (f) => f.name + '|' + f.size + '|' + f.lastModified;

        function showError(msg) {
            if (!errBox) return;
            errBox.textContent = msg || '';
            errBox.hidden = !msg;
        }

        function sync() {
            const dt = new DataTransfer();
            files.forEach((f) => dt.items.add(f));
            input.files = dt.files; // přiřazení programově nespustí change
        }

        function renderList() {
            if (!list) return;
            list.textContent = '';
            files.forEach((f, i) => {
                const li   = document.createElement('li');
                li.className = 'form-file-item';

                const name = document.createElement('span');
                name.className = 'form-file-item__name';
                name.textContent = f.name;

                const size = document.createElement('span');
                size.className = 'form-file-item__size';
                size.textContent = fmtSize(f.size);

                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'form-file-remove';
                btn.setAttribute('aria-label', 'Odebrat přílohu ' + f.name);
                btn.textContent = '×';
                btn.addEventListener('click', () => {
                    files.splice(i, 1);
                    sync();
                    renderList();
                    showError('');
                });

                li.append(name, size, btn);
                list.appendChild(li);
            });
        }

        input.addEventListener('change', () => {
            const incoming = Array.from(input.files || []);
            let err = '';
            incoming.forEach((f) => {
                if (files.some((e) => keyOf(e) === keyOf(f))) return; // už přidaný
                if (f.size > maxSize) { err = 'Soubor „' + f.name + '" je příliš velký.'; return; }
                if (files.length >= maxFiles) { err = 'Přiložit lze nejvýš ' + maxFiles + ' souborů.'; return; }
                files.push(f);
            });
            showError(err);
            sync();
            renderList();
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initChoices();
    initFileInputs();
});
